/**
 * CAMACTIVE Project Version Information
 * Auto-generated on 2026-09-16T20:17:49.543Z
 */

export const VERSION = '1.0.599';
export const VERSION_MAJOR = 1;
export const VERSION_MINOR = 0;
export const VERSION_REVISION = 599;
export const BUILD_TIME = '2026-09-16T20:17:49.543Z';
export const BUILD_COMMIT = import.meta.env.VITE_BUILD_COMMIT || 'development';

// Version object for easy access
export const VERSION_INFO = {
    full: VERSION,
    major: VERSION_MAJOR,
    minor: VERSION_MINOR,
    revision: VERSION_REVISION,
    buildTime: BUILD_TIME,
    commit: BUILD_COMMIT,
    toString() {
        return this.full;
    },
    compare(other) {
        const parseVer = (v) => v.split('.').map(Number);
        const [a1, a2, a3] = parseVer(this.full);
        const [b1, b2, b3] = parseVer(other);

        if (a1 !== b1) return a1 - b1;
        if (a2 !== b2) return a2 - b2;
        return a3 - b3;
    }
};

export default VERSION_INFO;
